import { useState, useEffect } from 'react';
import * as api from '../api/index'; // Adjust path to your API file

const usePermissions = () => {
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const profile = JSON.parse(localStorage.getItem("profile")) || {};
        if (!profile.token) throw new Error("No token found in localStorage");

        const { data } = await api.getUserPermissions();
        setPermissions(data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching permissions:", err.message);
        setPermissions({ pages: [], canApplyCustomDiscount: false, canDownloadPdfReports: false }); // Fallback
        setError(err.message);
        setLoading(false);
      }
    };
    fetchPermissions();
  }, []);

  // Helper functions to check specific permissions
  const canCreatePage = (pageName) => permissions?.pages?.find(p => p.pageName === pageName)?.canCreate || false;
  const canReadPage = (pageName) => permissions?.pages?.find(p => p.pageName === pageName)?.canRead || false;
  const canApplyDiscount = () => permissions?.canApplyCustomDiscount || false;
  const canDownloadReports = () => permissions?.canDownloadPdfReports || false;
  const canUpdatePage = (pageName) => permissions?.pages?.find(p => p.pageName === pageName)?.canUpdate || false;
  const canDeletePage = (pageName) => permissions?.pages?.find(p => p.pageName === pageName)?.canDelete || false;
  const isAdmin = () => {
    const profile = JSON.parse(localStorage.getItem("profile")) || {};
    return profile?.result?.userType?.includes("admin") || false;
  };

  return {
    permissions,
    loading,
    error,
    canApplyDiscount,
    canUpdatePage,
    canDeletePage,
    isAdmin,
    canCreatePage,
    canReadPage,
    canDownloadReports
  };
};

export default usePermissions;